<template>
    <select>
        <slot></slot>
    </select>
</template>
<script>
    import $ from 'jquery';
    import 'select2';

    export default {
        props: {
            options: {
                type: Array,
                default: () => [],
            },
            value: {
                type: String,
                default: ''
            },
            onchange: {
              type: String,
            },
            hideSearch: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: 'Bitte wählen'
            },
            noResults: {
                type: String,
                default: 'Keine Einträge verfügbar'
            },
        },
        mounted() {
            var vm = this;
            $(this.$el)
                // init select2
                .select2({
                    dropdownPosition: 'below',
                    data: [{id: ''}, ...this.options],
                    // minimumResultsForSearch: this.hideSearch ? Infinity : 3,
                    placeholder: !this.placeholder ? null : this.placeholder,
                    language: {
                        noResults: () => this.noResults
                    },
                    matcher: function(params, data) {
                      return vm.matchStart(params, data);
                    },
                })
                .val(this.value)
                .trigger("change")
                // emit event on change.
                .on("change", function (event) {
                    vm.$emit(vm.onchange, event);
                    vm.$emit("input", this.value);
            });

        },
        watch: {
            value: function (value) {
                // update value

                $(this.$el).val(value).trigger("change");
                // $(this.$el).trigger("change");
            },
            options: function (options) {
                var vm = this;
                // update options
                $(this.$el).empty().select2({
                    dropdownPosition: 'below',
                    data: [{id: ''}, ...options],
                    minimumResultsForSearch: this.hideSearch ? Infinity : 3,
                    placeholder: !this.placeholder ? null : this.placeholder,
                    language: {
                        noResults: () => this.noResults
                    },
                    matcher: function(params, data) {
                      return vm.matchStart(params, data);
                    },
                });
            },
        },
        destroyed: function () {
            $(this.$el).off().select2("destroy");
        },
        methods: {
          matchStart: function (params, data) {
            params.term = params.term || '';
            if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
              return data;
            }
            return false;
          }
        }
    };
</script>